import { Injectable } from '@angular/core';
import { BehaviorSubject, debounceTime, distinctUntilChanged, map, Observable, skip } from 'rxjs';

export interface AppState {
  // Configuration and device data
  configurationData: LegacyAny;
  readerConfigurationData: LegacyAny;

  // Reader information
  detectedReaderInfo: LegacyAny;
  readerInfo: LegacyAny;
  readerDevices: LegacyAny;
  readerDeviceFullInfo: LegacyAny;
  setReaderDEviceInfo: LegacyAny;

  // Device status
  isWriting: boolean;
  readingDevice: boolean;
  writingDevice: boolean;

  // Features
  resultFeatures: LegacyAny;
  supporteFeatures: LegacyAny;
  writeDeviceFeatures: LegacyAny[];

  // Flow control
  normalFlow: boolean;
  loadffflow: LegacyAny;

  // Multi-device
  storeConcecutiveMultiple: LegacyAny;
  multidevice: LegacyAny;
  pluginOut: LegacyAny;

  // Product information
  prodInfoStatus: string;
  showContinueNow: string;
  readContinue: string;

  // Configuration
  saveSetData: LegacyAny;
  saveSetData1: LegacyAny;
  saveReadValue: LegacyAny;
  UnSelectedFeatConfig: LegacyAny;

  // Tags and modes
  tags: LegacyAny;
  modes: LegacyAny;

  // Firmware and versions
  comparefirmwarenoLatest: LegacyAny;
  latestDcsVersion: LegacyAny;
  statusCallDataSwVersion: LegacyAny;
  softwareSchema: LegacyAny;

  // Other data
  NFC_Protocol: LegacyAny;
  deviceVersion: LegacyAny;
  deviceDataLength: LegacyAny;
  corruptedDevicesCount: LegacyAny;
  corruptMemoryBankId: LegacyAny;
  selectedInterface: LegacyAny;
  configId: LegacyAny;
  uniqueconfigidset: LegacyAny;
  storeConfigMode: LegacyAny;
  fromDeviceList: string;
  compatibleFeatureID: LegacyAny;
  storeFilter: LegacyAny;
  CCTBoolen: LegacyAny;
  importFeatureData: LegacyAny;
  dynaDimmerSchema: LegacyAny;
  quickConfiguration: LegacyAny;
  aocSchema: LegacyAny;
  dynaSaveSetData: LegacyAny;
  setmode: LegacyAny;
  exportedFeatureFile: boolean;
  storeSaveFeatureFile: LegacyAny;
  storeDCFFile: LegacyAny;
  storeOmitOption: LegacyAny;
  remoteSwVersion: LegacyAny;
  setLastSoftwareVersion: LegacyAny;
  device12nc: LegacyAny;

  // Table/UI state
  storeColumn: LegacyAny;
  lastSorting: LegacyAny;
  saveCheckedDevice: LegacyAny;
  sortCol: LegacyAny;

  // File-related
  saveFileName: string;
  saveFileContent: string;
  decryptData: LegacyAny;
  compatible: LegacyAny;

  // Modal state
  closeConfigureModal: boolean;

  // LIP feature values
  InputPower100: string;
  InputPower1001: string;
  InputPowerDim: string;
  DimLevel: string;
  cloPoints: string;
  cloPointsStepValue: string;

  // Feature flags
  featureFileCReation: boolean;
  excludedDCFeat: LegacyAny;
  isAloMin: boolean;
  dynaScenes: LegacyAny;

  // Authentication
  currentUser: LegacyAny;
  expires_in: string;
  logout: string;
  lastActive: string;
  refreshZtvData: LegacyAny;
}

@Injectable({
  providedIn: 'root'
})
export class AppStateService {
  private readonly initialState: AppState = {
    configurationData: null,
    readerConfigurationData: null,
    detectedReaderInfo: null,
    readerInfo: null,
    readerDevices: null,
    readerDeviceFullInfo: [],
    setReaderDEviceInfo: null,
    isWriting: false,
    readingDevice: false,
    writingDevice: false,
    resultFeatures: null,
    supporteFeatures: null,
    writeDeviceFeatures: [],
    normalFlow: true,
    loadffflow: null,
    storeConcecutiveMultiple: null,
    multidevice: null,
    pluginOut: null,
    prodInfoStatus: 'no',
    showContinueNow: 'no',
    readContinue: null,
    saveSetData: null,
    saveSetData1: null,
    saveReadValue: null,
    UnSelectedFeatConfig: [],
    tags: null,
    modes: null,
    comparefirmwarenoLatest: null,
    latestDcsVersion: null,
    statusCallDataSwVersion: null,
    softwareSchema: null,
    NFC_Protocol: null,
    deviceVersion: null,
    deviceDataLength: null,
    corruptedDevicesCount: null,
    corruptMemoryBankId: null,
    selectedInterface: null,
    configId: null,
    uniqueconfigidset: null,
    storeConfigMode: null,
    fromDeviceList: null,
    compatibleFeatureID: null,
    storeFilter: null,
    CCTBoolen: null,
    importFeatureData: null,
    dynaDimmerSchema: null,
    quickConfiguration: null,
    aocSchema: null,
    dynaSaveSetData: null,
    setmode: null,
    exportedFeatureFile: false,
    storeSaveFeatureFile: null,
    storeDCFFile: null,
    storeOmitOption: null,
    remoteSwVersion: null,
    setLastSoftwareVersion: null,
    device12nc: null,

    // Table/UI state
    storeColumn: null,
    lastSorting: null,
    saveCheckedDevice: null,
    sortCol: null,

    // File-related
    saveFileName: null,
    saveFileContent: null,
    decryptData: null,
    compatible: null,

    // Modal state
    closeConfigureModal: false,

    // LIP feature values
    InputPower100: null,
    InputPower1001: null,
    InputPowerDim: null,
    DimLevel: null,
    cloPoints: null,
    cloPointsStepValue: null,

    // Feature flags
    featureFileCReation: false,
    excludedDCFeat: null,
    isAloMin: false,
    dynaScenes: null,

    // Authentication
    currentUser: null,
    expires_in: null,
    logout: null,
    lastActive: null,
    refreshZtvData: null
  };

  private state$ = new BehaviorSubject<AppState>(this.initialState);
  private readonly STORAGE_KEY = 'configurationData';
  private readonly PERSIST_DEBOUNCE_MS = 500; // Debounce writes to avoid excessive sessionStorage operations

  private readonly beforeUnloadHandler = () => this.forcePersistState();

  constructor() {
    // Load initial state from sessionStorage (single read on app startup)
    this.loadStateFromStorage();

    // Auto-persist state changes to sessionStorage (debounced to prevent excessive writes)
    // Skip first emission (initial state) to avoid unnecessary write
    this.state$.pipe(
      skip(1),
      debounceTime(this.PERSIST_DEBOUNCE_MS)
    ).subscribe(state => {
      this.persistStateToStorage(state);
    });

    // Force-persist state before browser refresh/close to prevent data loss
    // from the debounce delay
    window.addEventListener('beforeunload', this.beforeUnloadHandler);
  }

  /**
   * Load state from sessionStorage on app initialization
   * This is the ONLY place in the entire app that reads from sessionStorage
   */
  private loadStateFromStorage(): void {
    try {
      const stored = sessionStorage.getItem(this.STORAGE_KEY);
      if (stored) {
        const parsedState = JSON.parse(stored);
        // Merge with initial state to handle LegacyAny new properties added in updates
        const mergedState = { ...this.initialState, ...parsedState };
        this.state$.next(mergedState);
      }
    } catch {
      // Continue with initial state if sessionStorage data is invalid or unavailable
    }
  }

  /**
   * Persist current state to sessionStorage
   * This is the ONLY place in the entire app that writes to sessionStorage
   * Debounced via constructor subscription to prevent excessive writes
   */
  private persistStateToStorage(state: AppState): void {
    try {
      sessionStorage.setItem(this.STORAGE_KEY, this.safeStringify(state));
    } catch (error) {
      console.error('Error persisting state to sessionStorage:', error);
      // Handle quota exceeded, privacy mode, etc.
    }
  }

  private safeStringify(value: unknown): string {
    const seen = new WeakSet<object>();
    return JSON.stringify(value, (_key, currentValue) => {
      if (currentValue && typeof currentValue === 'object') {
        if (seen.has(currentValue as object)) {
          return undefined;
        }
        seen.add(currentValue as object);
      }
      return currentValue;
    });
  }

  /**
   * Force immediate save to sessionStorage without debounce
   * Use this before critical operations like page reload to ensure data is persisted
   */
  public forcePersistState(): void {
    this.persistStateToStorage(this.state$.value);
  }

  /**
   * Clear persisted state from sessionStorage
   * Use this when user logs out or wants to reset the application
   */
  public clearPersistedState(): void {
    try {
      sessionStorage.removeItem(this.STORAGE_KEY);
    } catch (error) {
      console.error('Error clearing persisted state:', error);
    }
  }

  // Get the entire state
  getState(): Observable<AppState> {
    return this.state$.asObservable();
  }

  // Get current state snapshot
  getStateSnapshot(): AppState {
    return this.state$.value;
  }

  // Update the entire state
  setState(newState: Partial<AppState>): void {
    this.state$.next({ ...this.state$.value, ...newState });
  }

  private cloneStateValue<T>(value: T): T {
    if (value === null || value === undefined) {
      return value;
    }

    try {
      return JSON.parse(JSON.stringify(value));
    } catch {
      return value;
    }
  }

  // Configuration Data
  setConfigurationData(data: LegacyAny): void {
    // If data is null/undefined, clear everything
    if (!data) {
      this.setState({ configurationData: null });
      return;
    }

    const current = this.state$.value.configurationData;

    // Merge with existing configurationData to preserve important properties
    let mergedData = data;

    // Preserve selectedFeaturesInfo logic:
    // 1. If current has non-empty selections and incoming is empty/missing †’ preserve current (prevents accidental wipe)
    // 2. If current has empty/LegacyAny selections and incoming doesn't have the property †’ preserve current
    // 3. If incoming has non-empty selections †’ use incoming (intentional update)
    const currentHasFeatureInfo = current?.selectedFeaturesInfo !== undefined &&
        Array.isArray(current.selectedFeaturesInfo);
    const currentHasNonEmptySelections = currentHasFeatureInfo &&
        current.selectedFeaturesInfo.length > 0;
    const incomingHasProperty = data.hasOwnProperty('selectedFeaturesInfo');
    const incomingHasNonEmptySelections = incomingHasProperty &&
        Array.isArray(data.selectedFeaturesInfo) &&
        data.selectedFeaturesInfo.length > 0;

    if (currentHasNonEmptySelections && !incomingHasNonEmptySelections) {
      // Protect non-empty selections from being wiped by empty/missing incoming data
      mergedData = {
        ...mergedData,
        selectedFeaturesInfo: current.selectedFeaturesInfo
      };
    } else if (currentHasFeatureInfo && !incomingHasProperty) {
      // Preserve existing (even empty) when incoming doesn't mention it at all
      mergedData = {
        ...mergedData,
        selectedFeaturesInfo: current.selectedFeaturesInfo
      };
    }

    // Preserve feature12Nc logic (existing)
    const shouldPreserve = current &&
                          !data.resp &&
                          Object.keys(data).length > 0;

    // Preserve feature12Nc only if not explicitly provided
    if (shouldPreserve && current?.feature12Nc && !data.hasOwnProperty('feature12Nc')) {
      mergedData = {
        ...mergedData,
        feature12Nc: current.feature12Nc
      };
    }

    // Preserve all luminfo versions in feature12Nc when updating
    // This handles the specific case of luminfo restore defaults
    if (current?.feature12Nc && data?.feature12Nc && data?.resp?.LumInfoFormat) {
      const currentLuminVersions = current.feature12Nc.filter((f: string) =>
        typeof f === 'string' && f.startsWith('luminfoformat')
      );
      const newLuminVersions = data.feature12Nc.filter((f: string) =>
        typeof f === 'string' && f.startsWith('luminfoformat')
      );

      // If we had multiple luminfo versions but new data has fewer, preserve all original versions
      if (currentLuminVersions.length > 1 && newLuminVersions.length < currentLuminVersions.length) {
        // Remove LegacyAny luminfo versions from new data
        const nonLuminFeatures = data.feature12Nc.filter((f: string) =>
          !f.toString().startsWith('luminfoformat')
        );
        // Add back all original luminfo versions
        mergedData = {
          ...mergedData,
          feature12Nc: [...nonLuminFeatures, ...currentLuminVersions]
        };
      }
    }

    this.setState({ configurationData: this.cloneStateValue(mergedData) });
  }

  /**
   * Explicitly update selectedFeaturesInfo in configurationData.
   * Use this when the user intentionally changes checkbox selections.
   * This bypasses the protection in setConfigurationData that prevents
   * accidental overwrites of selectedFeaturesInfo.
   */
  updateSelectedFeaturesInfo(features: string[]): void {
    const current = this.state$.value.configurationData;
    if (!current) return;
    const updated = { ...current, selectedFeaturesInfo: [...features] };
    this.setState({ configurationData: this.cloneStateValue(updated) });
  }

  getConfigurationData(): LegacyAny {
    return this.cloneStateValue(this.state$.value.configurationData);
  }

  getConfigurationData$(): Observable<LegacyAny> {
    return new Observable(observer => {
      this.state$.subscribe(state => observer.next(state.configurationData));
    });
  }

  // Reader Configuration Data
  setReaderConfigurationData(data: LegacyAny): void {
    this.setState({ readerConfigurationData: data });
  }

  getReaderConfigurationData(): LegacyAny {
    return this.state$.value.readerConfigurationData;
  }

  // Detected Reader Info
  setDetectedReaderInfo(data: LegacyAny): void {
    this.setState({ detectedReaderInfo: data });
  }

  getDetectedReaderInfo(): LegacyAny {
    return this.state$.value.detectedReaderInfo;
  }

  // Reader Info
  setReaderInfo(data: LegacyAny): void {
    this.setState({ readerInfo: data });
  }

  getReaderInfo(): LegacyAny {
    return this.state$.value.readerInfo;
  }

  removeReaderInfo(): void {
    this.setState({ readerInfo: null });
  }

  // Reader Devices
  setReaderDevices(data: LegacyAny): void {
    this.setState({ readerDevices: data });
  }

  getReaderDevices(): LegacyAny {
    return this.state$.value.readerDevices;
  }

  removeReaderDevices(): void {
    this.setState({ readerDevices: null });
  }

  // Reader Device Full Info
  setReaderDeviceFullInfo(data: LegacyAny): void {
    this.setState({ readerDeviceFullInfo: data });
  }

  getReaderDeviceFullInfo(): LegacyAny {
    return this.state$.value.readerDeviceFullInfo;
  }

  removeReaderDeviceFullInfo(): void {
    this.setState({ readerDeviceFullInfo: null });
  }

  // Set Reader Device Info
  setSetReaderDEviceInfo(data: LegacyAny): void {
    this.setState({ setReaderDEviceInfo: data });
  }

  getSetReaderDEviceInfo(): LegacyAny {
    return this.state$.value.setReaderDEviceInfo;
  }

  // Is Writing
  setIsWriting(value: boolean): void {
    this.setState({ isWriting: value });
  }

  getIsWriting(): boolean {
    return this.state$.value.isWriting;
  }

  // Reading Device
  setReadingDevice(value: boolean): void {
    this.setState({ readingDevice: value });
  }

  getReadingDevice(): boolean {
    return this.state$.value.readingDevice;
  }

  getReadingDeviceString(): string {
    return this.state$.value.readingDevice ? 'true' : 'false';
  }

  // Writing Device
  setWritingDevice(value: boolean): void {
    this.setState({ writingDevice: value });
  }

  getWritingDevice(): boolean {
    return this.state$.value.writingDevice;
  }

  // Result Features
  setResultFeatures(data: LegacyAny): void {
    this.setState({ resultFeatures: data });
  }

  getResultFeatures(): LegacyAny {
    return this.state$.value.resultFeatures || {};
  }

  removeResultFeatures(): void {
    this.setState({ resultFeatures: null });
  }

  // Supported Features
  setSupportedFeatures(data: LegacyAny): void {
    this.setState({ supporteFeatures: data });
  }

  getSupportedFeatures(): LegacyAny {
    return this.state$.value.supporteFeatures;
  }

  // Write Device Features
  setWriteDeviceFeatures(data: LegacyAny[]): void {
    this.setState({ writeDeviceFeatures: data });
  }

  getWriteDeviceFeatures(): LegacyAny[] {
    return this.state$.value.writeDeviceFeatures || [];
  }

  // Normal Flow
  setNormalFlow(value: boolean): void {
    this.setState({ normalFlow: value });
  }

  getNormalFlow(): boolean {
    return this.state$.value.normalFlow;
  }

  getNormalFlowString(): string {
    return JSON.stringify(this.state$.value.normalFlow);
  }

  // Load FF Flow
  setLoadffflow(data: LegacyAny): void {
    this.setState({ loadffflow: data });
  }

  getLoadffflow(): LegacyAny {
    return this.state$.value.loadffflow;
  }

  // Store Consecutive Multiple
  setStoreConcecutiveMultiple(data: LegacyAny): void {
    this.setState({ storeConcecutiveMultiple: data });
  }

  getStoreConcecutiveMultiple(): LegacyAny {
    return this.state$.value.storeConcecutiveMultiple;
  }

  // Multi Device
  setMultidevice(data: LegacyAny): void {
    this.setState({ multidevice: data });
  }

  getMultidevice(): LegacyAny {
    return this.state$.value.multidevice;
  }

  // Plugin Out
  setPluginOut(data: LegacyAny): void {
    this.setState({ pluginOut: data });
  }

  getPluginOut(): LegacyAny {
    return this.state$.value.pluginOut;
  }

  // Product Info Status
  setProdInfoStatus(status: string): void {
    this.setState({ prodInfoStatus: status });
  }

  getProdInfoStatus(): string {
    return this.state$.value.prodInfoStatus;
  }

  // Show Continue Now
  setShowContinueNow(value: string): void {
    this.setState({ showContinueNow: value });
  }

  getShowContinueNow(): string {
    return this.state$.value.showContinueNow;
  }

  // Read Continue
  setReadContinue(value: string): void {
    this.setState({ readContinue: value });
  }

  getReadContinue(): string {
    return this.state$.value.readContinue;
  }

  // Save Set Data
  setSaveSetData(data: LegacyAny): void {
    this.setState({ saveSetData: data });
  }

  getSaveSetData(): LegacyAny {
    return this.state$.value.saveSetData;
  }

  removeSaveSetData(): void {
    this.setState({ saveSetData: null });
  }

  // Save Read Value
  setSaveReadValue(data: LegacyAny): void {
    this.setState({ saveReadValue: data });
  }

  getSaveReadValue(): LegacyAny {
    return this.state$.value.saveReadValue;
  }

  removeSaveReadValue(): void {
    this.setState({ saveReadValue: null });
  }

  // UnSelected Feature Config
  setUnSelectedFeatConfig(data: LegacyAny): void {
    this.setState({ UnSelectedFeatConfig: data });
  }

  getUnSelectedFeatConfig(): LegacyAny {
    return this.state$.value.UnSelectedFeatConfig;
  }

  // Tags
  setTags(data: LegacyAny): void {
    this.setState({ tags: data });
  }

  getTags(): LegacyAny {
    return this.state$.value.tags;
  }

  // Modes
  setModes(data: LegacyAny): void {
    this.setState({ modes: data });
  }

  getModes(): LegacyAny {
    return this.state$.value.modes;
  }

  // Compare Firmware No Latest
  setCompareFirmwareNoLatest(data: LegacyAny): void {
    this.setState({ comparefirmwarenoLatest: data });
  }

  getCompareFirmwareNoLatest(): LegacyAny {
    return this.state$.value.comparefirmwarenoLatest;
  }

  // NFC Protocol
  setNFCProtocol(data: LegacyAny): void {
    this.setState({ NFC_Protocol: data });
  }

  getNFCProtocol(): LegacyAny {
    return this.state$.value.NFC_Protocol;
  }

  removeNFCProtocol(): void {
    this.setState({ NFC_Protocol: null });
  }

  // Device Version
  setDeviceVersion(data: LegacyAny): void {
    this.setState({ deviceVersion: data });
  }

  getDeviceVersion(): LegacyAny {
    return this.state$.value.deviceVersion;
  }

  removeDeviceVersion(): void {
    this.setState({ deviceVersion: null });
  }

  // Device Data Length
  setDeviceDataLength(length: LegacyAny): void {
    this.setState({ deviceDataLength: length });
  }

  getDeviceDataLength(): LegacyAny {
    return this.state$.value.deviceDataLength;
  }

  // Corrupted Devices Count
  setCorruptedDevicesCount(count: LegacyAny): void {
    this.setState({ corruptedDevicesCount: count });
  }

  getCorruptedDevicesCount(): LegacyAny {
    return this.state$.value.corruptedDevicesCount;
  }

  // Corrupt Memory Bank Id
  setCorruptMemoryBankId(data: LegacyAny): void {
    this.setState({ corruptMemoryBankId: data });
  }

  getCorruptMemoryBankId(): LegacyAny {
    return this.state$.value.corruptMemoryBankId;
  }

  removeCorruptMemoryBankId(): void {
    this.setState({ corruptMemoryBankId: null });
  }

  setSelectedInterface(data: LegacyAny): void {
    this.setState({ selectedInterface: data });
  }

  getSelectedInterface(): LegacyAny {
    return this.state$.value.selectedInterface;
  }

  // Config ID
  setConfigId(id: LegacyAny): void {
    this.setState({ configId: id });
  }

  getConfigId(): LegacyAny {
    return this.state$.value.configId;
  }

  // Unique Config ID Set
  setUniqueConfigIdSet(id: LegacyAny): void {
    this.setState({ uniqueconfigidset: id });
  }

  getUniqueConfigIdSet(): LegacyAny {
    return this.state$.value.uniqueconfigidset;
  }

  // Store Config Mode
  setStoreConfigMode(mode: LegacyAny): void {
    this.setState({ storeConfigMode: mode });
  }

  getStoreConfigMode(): LegacyAny {
    return this.state$.value.storeConfigMode;
  }

  // From Device List
  setFromDeviceList(value: string): void {
    this.setState({ fromDeviceList: value });
  }

  getFromDeviceList(): string {
    return this.state$.value.fromDeviceList;
  }

  // Compatible Feature ID
  setCompatibleFeatureID(id: LegacyAny): void {
    this.setState({ compatibleFeatureID: id });
  }

  getCompatibleFeatureID(): LegacyAny {
    return this.state$.value.compatibleFeatureID;
  }

  // Software Schema
  setSoftwareSchema(data: LegacyAny): void {
    this.setState({ softwareSchema: data });
  }

  getSoftwareSchema(): LegacyAny {
    return this.state$.value.softwareSchema;
  }

  // Store Filter
  setStoreFilter(data: LegacyAny): void {
    this.setState({ storeFilter: data });
  }

  getStoreFilter(): LegacyAny {
    return this.state$.value.storeFilter;
  }

  // CCT Boolean
  setCCTBoolen(value: LegacyAny): void {
    this.setState({ CCTBoolen: value });
  }

  getCCTBoolen(): LegacyAny {
    return this.state$.value.CCTBoolen;
  }

  removeCCTBoolen(): void {
    this.setState({ CCTBoolen: null });
  }

  // Import Feature Data
  setImportFeatureData(data: LegacyAny): void {
    this.setState({ importFeatureData: data });
  }

  getImportFeatureData(): LegacyAny {
    return this.state$.value.importFeatureData;
  }

  // DynaDimmer Schema
  setDynaDimmerSchema(data: LegacyAny): void {
    this.setState({ dynaDimmerSchema: data });
  }

  getDynaDimmerSchema(): LegacyAny {
    return this.state$.value.dynaDimmerSchema;
  }

  removeDynaDimmerSchema(): void {
    this.setState({ dynaDimmerSchema: null });
  }

  // Quick Configuration
  setQuickConfiguration(value: LegacyAny): void {
    this.setState({ quickConfiguration: value });
  }

  removeQuickConfiguration(): void {
    this.setState({ quickConfiguration: null });
  }

  getQuickConfiguration(): LegacyAny {
    return this.state$.value.quickConfiguration;
  }

  // SaveSetData1
  setSaveSetData1(data: LegacyAny): void {
    this.setState({ saveSetData1: data });
  }

  getSaveSetData1(): LegacyAny {
    return this.state$.value.saveSetData1;
  }

  // Latest DCS Version
  setLatestDcsVersion(version: LegacyAny): void {
    this.setState({ latestDcsVersion: version });
  }

  getLatestDcsVersion(): LegacyAny {
    return this.state$.value.latestDcsVersion;
  }

  // Status Call Data SW Version
  setStatusCallDataSwVersion(version: LegacyAny): void {
    this.setState({ statusCallDataSwVersion: version });
  }

  getStatusCallDataSwVersion(): LegacyAny {
    return this.state$.value.statusCallDataSwVersion;
  }

  // AOC Schema
  setAocSchema(data: LegacyAny): void {
    this.setState({ aocSchema: data });
  }

  getAocSchema(): LegacyAny {
    return this.state$.value.aocSchema;
  }

  // Dyna Save Set Data
  setDynaSaveSetData(data: LegacyAny): void {
    this.setState({ dynaSaveSetData: data });
  }

  getDynaSaveSetData(): LegacyAny {
    return this.state$.value.dynaSaveSetData;
  }

  // Set Mode
  setSetmode(data: LegacyAny): void {
    this.setState({ setmode: data });
  }

  getSetmode(): LegacyAny {
    return this.state$.value.setmode;
  }

  removeSetmode(): void {
    this.setState({ setmode: null });
  }

  // Exported Feature File
  setExportedFeatureFile(value: boolean): void {
    this.setState({ exportedFeatureFile: value });
  }

  getExportedFeatureFile(): boolean {
    return this.state$.value.exportedFeatureFile;
  }

  // Store Save Feature File
  setStoreSaveFeatureFile(data: LegacyAny): void {
    this.setState({ storeSaveFeatureFile: data });
  }

  getStoreSaveFeatureFile(): LegacyAny {
    return this.state$.value.storeSaveFeatureFile;
  }

  // Store DCF File
  setStoreDCFFile(data: LegacyAny): void {
    this.setState({ storeDCFFile: data });
  }

  getStoreDCFFile(): LegacyAny {
    return this.state$.value.storeDCFFile;
  }

  // Store Omit Option
  setStoreOmitOption(data: LegacyAny): void {
    this.setState({ storeOmitOption: data });
  }

  getStoreOmitOption(): LegacyAny {
    return this.state$.value.storeOmitOption;
  }

  // Remote SW Version
  setRemoteSwVersion(version: LegacyAny): void {
    this.setState({ remoteSwVersion: version });
  }

  getRemoteSwVersion(): LegacyAny {
    return this.state$.value.remoteSwVersion;
  }

  // Set Last Software Version
  setSetLastSoftwareVersion(version: LegacyAny): void {
    this.setState({ setLastSoftwareVersion: version });
  }

  getSetLastSoftwareVersion(): LegacyAny {
    return this.state$.value.setLastSoftwareVersion;
  }

  // Config ID Remove
  // Config ID Remove
  removeConfigId(): void {
    this.setState({ configId: null });
  }

  // Helper methods
  removeImportFeatureData(): void {
    this.setState({ importFeatureData: null });
  }

  // Device 12NC
  setDevice12nc(device12nc: LegacyAny): void {
    this.setState({ device12nc: device12nc });
  }

  getDevice12nc(): LegacyAny {
    return this.state$.value.device12nc;
  }

  removeDevice12nc(): void {
    this.setState({ device12nc: null });
  }

  removeWriteDeviceFeatures(): void {
    this.setState({ writeDeviceFeatures: [] });
  }

  // Clear specific state properties
  clearReadFlow(): void {
    this.setState({
      normalFlow: false,
      CCTBoolen: null,
      saveReadValue: null,
      resultFeatures: null,
      supporteFeatures: null,
      configurationData: null,
      saveSetData1: null,
      readerDeviceFullInfo: null,
      saveSetData: null,
      importFeatureData: null,
      quickConfiguration: null,
      writeDeviceFeatures: [],
      loadffflow: null,
      isWriting: false
    });
    this.forcePersistState();
  }

  // Reset entire state
  resetState(): void {
    this.state$.next(this.initialState);
    this.clearPersistedState();
  }

  // Table/UI state getters and setters
  setStoreColumn(data: LegacyAny): void {
    this.setState({ storeColumn: data });
  }

  getStoreColumn(): LegacyAny {
    return this.state$.value.storeColumn;
  }

  removeStoreColumn(): void {
    this.setState({ storeColumn: null });
  }

  removeStoreFilter(): void {
    this.setState({ storeFilter: null });
  }

  removeStoreLastColumnCheck(): void {
    // Removes the entire lastSorting object
    this.setState({ lastSorting: null });
  }

  removeStoreConfigMode(): void {
    this.setState({ storeConfigMode: null });
  }

  removeStoreOmitOption(): void {
    this.setState({ storeOmitOption: null });
  }

  setLastSorting(data: LegacyAny): void {
    this.setState({ lastSorting: data });
  }

  getLastSorting(): LegacyAny {
    return this.state$.value.lastSorting;
  }

  removeLastSorting(): void {
    this.setState({ lastSorting: null });
  }

  setSaveCheckedDevice(data: LegacyAny): void {
    this.setState({ saveCheckedDevice: data });
  }

  getSaveCheckedDevice(): LegacyAny {
    return this.state$.value.saveCheckedDevice;
  }

  removeSaveCheckedDevice(): void {
    this.setState({ saveCheckedDevice: null });
  }

  setSortCol(data: LegacyAny): void {
    this.setState({ sortCol: data });
  }

  getSortCol(): LegacyAny {
    return this.state$.value.sortCol;
  }

  // File-related getters and setters
  setSaveFileName(name: string): void {
    this.setState({ saveFileName: name });
  }

  getSaveFileName(): string {
    return this.state$.value.saveFileName;
  }

  setSaveFileContent(content: string): void {
    this.setState({ saveFileContent: content });
  }

  getSaveFileContent(): string {
    return this.state$.value.saveFileContent;
  }

  setDecryptData(data: LegacyAny): void {
    this.setState({ decryptData: data });
  }

  getDecryptData(): LegacyAny {
    return this.state$.value.decryptData;
  }

  setCompatible(data: LegacyAny): void {
    this.setState({ compatible: data });
  }

  getCompatible(): LegacyAny {
    return this.state$.value.compatible;
  }

  // Modal state
  setCloseConfigureModal(value: boolean): void {
    this.setState({ closeConfigureModal: value });
  }

  getCloseConfigureModal(): boolean {
    return this.state$.value.closeConfigureModal;
  }

  removeCloseConfigureModal(): void {
    this.setState({ closeConfigureModal: false });
  }

  // LIP feature values
  setInputPower100(value: string): void {
    this.setState({ InputPower100: value });
  }

  getInputPower100(): string {
    return this.state$.value.InputPower100;
  }

  removeInputPower100(): void {
    this.setState({ InputPower100: null });
  }

  setInputPower1001(value: string): void {
    this.setState({ InputPower1001: value });
  }

  getInputPower1001(): string {
    return this.state$.value.InputPower1001;
  }

  removeInputPower1001(): void {
    this.setState({ InputPower1001: null });
  }

  setInputPowerDim(value: string): void {
    this.setState({ InputPowerDim: value });
  }

  getInputPowerDim(): string {
    return this.state$.value.InputPowerDim;
  }

  removeInputPowerDim(): void {
    this.setState({ InputPowerDim: null });
  }

  setDimLevel(value: string): void {
    this.setState({ DimLevel: value });
  }

  getDimLevel(): string {
    return this.state$.value.DimLevel;
  }

  removeDimLevel(): void {
    this.setState({ DimLevel: null });
  }

  setCloPoints(value: string): void {
    this.setState({ cloPoints: value });
  }

  getCloPoints(): string {
    return this.state$.value.cloPoints;
  }

  // Feature flags
  setFeatureFileCReation(value: boolean): void {
    this.setState({ featureFileCReation: value });
  }

  getFeatureFileCReation(): boolean {
    return this.state$.value.featureFileCReation;
  }

  removeFeatureFileCReation(): void {
    this.setState({ featureFileCReation: false });
  }

  removeCloPoints(): void {
    this.setState({ cloPoints: null });
  }

  setCloPointsStepValue(value: string): void {
    this.setState({ cloPointsStepValue: value });
  }

  getCloPointsStepValue(): string {
    return this.state$.value.cloPointsStepValue;
  }

  removeCloPointsStepValue(): void {
    this.setState({ cloPointsStepValue: null });
  }

  setExcludedDCFeat(value: LegacyAny): void {
    this.setState({ excludedDCFeat: value });
  }

  getExcludedDCFeat(): LegacyAny {
    return this.state$.value.excludedDCFeat;
  }

  removeExcludedDCFeat(): void {
    this.setState({ excludedDCFeat: null });
  }

  setIsAloMin(value: boolean): void {
    this.setState({ isAloMin: value });
  }

  getIsAloMin(): boolean {
    return this.state$.value.isAloMin;
  }

  setDynaScenes(data: LegacyAny): void {
    this.setState({ dynaScenes: data });
  }

  getDynaScenes(): LegacyAny {
    return this.state$.value.dynaScenes;
  }

  removeDynaScenes(): void {
    this.setState({ dynaScenes: null });
  }

  // Authentication
  setCurrentUser(user: LegacyAny): void {
    this.setState({ currentUser: user });
  }

  getCurrentUser(): LegacyAny {
    return this.state$.value.currentUser;
  }

  removeCurrentUser(): void {
    this.setState({ currentUser: null });
  }

  setExpiresIn(value: string): void {
    this.setState({ expires_in: value });
  }

  getExpiresIn(): string {
    return this.state$.value.expires_in;
  }

  removeExpiresIn(): void {
    this.setState({ expires_in: null });
  }

  setLogout(value: string): void {
    this.setState({ logout: value });
  }

  getLogout(): string {
    return this.state$.value.logout;
  }

  setLastActive(value: string): void {
    this.setState({ lastActive: value });
  }

  getLastActive(): string {
    return this.state$.value.lastActive;
  }

  removeLastActive(): void {
    this.setState({ lastActive: null });
  }

  setRefreshZtvData(data: LegacyAny): void {
    this.setState({ refreshZtvData: data });
  }

  getRefreshZtvData(): LegacyAny {
    return this.state$.value.refreshZtvData;
  }

  /**
   * CENTRALIZED FEATURE DATA MANAGEMENT
   *
   * These methods provide a single, consistent way for all features to load and save data.
   *
   * DATA PRIORITY ORDER (for loading):
   * 1. SaveSetData - Latest user-configured values (takes precedence over everything)
   * 2. ConfigurationData - Device defaults or read device values
   *
   * SAVING STRATEGY:
   * - Always save to BOTH ConfigurationData AND SaveSetData
   * - This ensures values persist across refresh and are available immediately
   */

  /**
   * Get feature data with correct priority order
   * @param featureName - Name of the feature (e.g., 'TouchDim', 'Ast', 'LumInfoFormat')
   * @returns Feature data object or null if not found
   */
  getFeatureData(featureName: string): LegacyAny {
    // Priority 1: Check SaveSetData (user-configured values)
    const saveSetData = this.getSaveSetData();
    if (saveSetData?.resp?.[featureName]) {
      return saveSetData.resp[featureName];
    }

    // Priority 2: Check ConfigurationData (device defaults/read values)
    const configData = this.getConfigurationData();
    if (configData?.resp?.[featureName]) {
      return configData.resp[featureName];
    }

    // No data found
    return null;
  }

  /**
   * Set feature data to both ConfigurationData and SaveSetData
   * @param featureName - Name of the feature (e.g., 'TouchDim', 'Ast', 'LumInfoFormat')
   * @param featureData - The feature data object to save
   */
  setFeatureData(featureName: string, featureData: LegacyAny): void {
    // Update ConfigurationData
    const configData = this.getConfigurationData() || {};
    if (!configData.resp) {
      configData.resp = {};
    }
    configData.resp[featureName] = { ...featureData };
    this.setConfigurationData(configData);

    // Update SaveSetData (deep copy to avoid reference issues)
    const saveSetDataCopy = JSON.parse(JSON.stringify(configData));
    this.setSaveSetData(saveSetDataCopy);
  }

  /**
   * Observable stream of feature data changes
   * @param featureName - Name of the feature to watch
   * @returns Observable that emits when feature data changes
   */
  getFeatureData$(featureName: string): Observable<LegacyAny> {
    return this.getState().pipe(
      map((state) => {
        // Check SaveSetData first, then ConfigurationData
        const saveData = state.saveSetData?.resp?.[featureName];
        const configData = state.configurationData?.resp?.[featureName];
        return saveData || configData || null;
      }),
      distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr))
    );
  }
}
